import React from "react";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";
import {BlockContainer} from "BaseComponents/Wrappers";
import {useGlobal} from "reactn";
import {H2} from "BaseComponents/Text";
import styled from "styled-components";
import {Video} from "Components/Video";

export const VideoBlock = ({Heading, Videos, UseTwoColumnLayout}) => {
    const [theme] = useGlobal("theme");
    return (
        Videos.length > 0 && (
            <BlockContainer className={"VideoBlock"}>
                <VideoBlockContainer>
                    <Header
                        inline
                        margin="0 0 0 0rem"
                        marginsmall="0 0 0 0"
                        color={theme.colors.black}
                    >
                        {Heading}
                    </Header>
                    <VideoBlockWrapper>
                        {Videos.map((video, i) => {
                            return (
                                <VideoWrapper key={i} useTwoColumnLayout={UseTwoColumnLayout}>
                                    <Video
                                        isBlock
                                        {...video}
                                        key={i}
                                        videoHeight={undefined}
                                        useTwoColumnLayout={UseTwoColumnLayout}
                                    />
                                </VideoWrapper>
                            );
                        })}
                    </VideoBlockWrapper>
                </VideoBlockContainer>
            </BlockContainer>
        )
    );
};

export const Header = styled(H2)`
    & {
        font-size: 26px;
    }
`;
export const VideoWrapper =  styled.div`
    ${media.greaterThan(breakpoints.mobile)`
	max-width: ${({useTwoColumnLayout}) => useTwoColumnLayout ? "calc(50% - 10px)" : "100%"};	
	width: 100%;
	height: auto;
`}
    margin: 10px 0;
    flex-direction: column;
    height: unset;
`;
export const VideoBlockContainer = styled.div`
    ${media.lessThan(breakpoints.mobile)`
  padding: 0;

  `}
`;
export const ArticleBlockOuterWrapper = styled.div`
    max-width: ${({theme}) => theme.grid.outer};
    width: auto;
    padding: 0;

    ${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        width: auto;
    `}
`;

export const VideoBlockWrapper = styled.div`
    width: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    ${media.lessThan(breakpoints.mobile)`
	margin: 0;
        flex-direction: column;
    `}
`;
